// src/api/xoe/XoeMemoriesApi.ts
// Practitioner + clinic scope Xoe memory (ClickUp 14ygtkj83tv S10), on the `XoeSettingsApi.ts` shape.
// Base is `VITE_XOE_AGENT_SERVER` (already `/api`-suffixed): memory state follows the turn, like conversations.

import { ENV } from "../../config/runtimeEnv";
import {
	CreateXoeMemoryPayload,
	ListXoeMemoriesParams,
	XoeMemory,
} from "../../types/xoe/XoeMemoryTypes";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_XOE_AGENT_SERVER;
const MEMORIES_PATH = "/practitioner/xoe/memories";

/** Newest first. Omitting `status` returns proposed + confirmed. */
export const listXoeMemories = async ({ scope, status }: ListXoeMemoriesParams): Promise<XoeMemory[]> => {
	const response = await http.get(`${API_BASE_URL}${MEMORIES_PATH}`, {
		params: status ? { scope, status } : { scope },
	});
	return response.data.data;
};

/** Lands confirmed, `source=practitioner`. 409 when the D34 cap is reached. */
export const createXoeMemory = async (payload: CreateXoeMemoryPayload): Promise<XoeMemory> => {
	const response = await http.post(`${API_BASE_URL}${MEMORIES_PATH}`, payload);
	return response.data.data;
};

type Transition = "confirm" | "dismiss" | "withdraw" | "restore";

// 404 = not visible, 403 = D33 governance refusal, 409 = wrong state, 410 = restore window expired.
const transition = async (memoryId: string, verb: Transition): Promise<XoeMemory> => {
	const response = await http.post(
		`${API_BASE_URL}${MEMORIES_PATH}/${memoryId}/${verb}`,
		{}
	);
	return response.data.data;
};

export const confirmXoeMemory = (memoryId: string): Promise<XoeMemory> => transition(memoryId, "confirm");
export const dismissXoeMemory = (memoryId: string): Promise<XoeMemory> => transition(memoryId, "dismiss");
export const withdrawXoeMemory = (memoryId: string): Promise<XoeMemory> => transition(memoryId, "withdraw");
export const restoreXoeMemory = (memoryId: string): Promise<XoeMemory> => transition(memoryId, "restore");
